import { render, staticRenderFns } from "./bsp-table-bak.vue?vue&type=template&id=6f3a1b50&scoped=true&"
import script from "./bsp-table-bak.vue?vue&type=script&lang=js&"
export * from "./bsp-table-bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a1b50",
  null
  
)

export default component.exports